module.exports = __webpack_public_path__ + "static/media/merlinIcons.5c8cc52c.svg";